export default {
      id: "circle__hidden-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__hidden",
      toString: function () {
        return this.url;
      }
    }